import { render, staticRenderFns } from "./BreakdownModal.vue?vue&type=template&id=674366f9&"
import script from "./BreakdownModal.vue?vue&type=script&lang=js&"
export * from "./BreakdownModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports